module.exports = __webpack_public_path__ + "img/accessory_item_10.e5c1c87b.svg";